import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  isEnabled: boolean;
  children: ReactNode;
};

// Labels the table as an advertisement and boxes it in a blue border.
export function AdvertiserWrapper({ isEnabled, children }: Props) {
  if (!isEnabled) return <>{children}</>;

  return (
    <Box
      component="section"
      aria-label="Advertisement"
      sx={{ display: 'flex', flexDirection: 'column' }}
    >
      <Typography
        component="p"
        sx={{
          alignSelf: 'flex-start',
          backgroundColor: 'blues.lighter',
          paddingX: 1,
          paddingY: 0.5,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.0625em',
          textTransform: 'uppercase',
        }}
      >
        Advertisement
      </Typography>
      <Box
        data-testid="advertiser-wrapper"
        sx={{
          minWidth: 0,
          padding: 2,
          border: '4px solid',
          borderColor: 'blues.lighter',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
